import clsx from 'clsx';
import React, { ReactNode, useRef, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';
import { useClickOutside } from '../../utils/clickOutSide';
import { formatDate } from '../../utils/dateFormat';
import CalenderIcon from '../../assets/icons/calender-icon.svg?react';
interface DatePickerProps {
  otherClasses?: {
    container?: string;
    input?: string;
    label?: string;
    dropdownMainContainer?: string;
  };
  label?: string | ReactNode;
  name: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<string>) => void;
  errorMessage?: string;
  disabled?: boolean;
  customDate?: boolean;
  onBlur?: (e: any) => void;
  startMonth?: Date;
  endMonth?: Date;
}

const DatePicker: React.FC<DatePickerProps> = ({
  otherClasses,
  label,
  name,
  placeholder,
  value,
  onChange,
  errorMessage,
  disabled,
  onBlur,
  startMonth,
  endMonth,
  customDate,
}) => {
  const datePickerClasses = clsx(
    otherClasses?.container,
    'flex flex-col gap-2.5 items-start relative w-fit relative',
  );
  const inputClasses = clsx(
    otherClasses?.input,
    'w-full h-60 global-transition  px-5 rounded-10 placeholder:text-neutral-tones-text/50 text-neutral-tones-text ring -tracking-form-input p-5 text-base font-normal font-inter-variable outline-none disabled:ring-neutral-tones-text/35 disabled:placeholder:text-neutral-tones-text/35 disabled:text-neutral-tones-text/35 disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
    errorMessage !== ''
      ? 'ring-brand-posh-pink ring-2'
      : 'ring-neutral-tones-text/50 focus:ring-2 focus:ring-brand-byzantine',
  );
  const labelClasses = clsx(
    otherClasses?.label,
    'text-form-label  font-bold -tracking-form-label font-inter-variable',
    disabled
      ? 'text-neutral-tones-text/35 cursor-not-allowed'
      : 'text-neutral-tones-text',
  );
  const [toggle, setToggle] = useState(false);
  const [month, setMonth] = useState(new Date());
  const ref = useRef(null);
  useClickOutside({ ref, setToggle });
  const formatedDate = formatDate(value);

  return (
    <div ref={ref} className={datePickerClasses} data-testid="date-picker">
      {label && (
        <label htmlFor={name} className={labelClasses}>
          {label}
        </label>
      )}
      <input
        disabled={disabled}
        id={name}
        type="text"
        name={name}
        value={customDate ? value : formatedDate ? formatedDate : ''}
        placeholder={placeholder}
        onClick={() => setToggle(!toggle)}
        onBlur={onBlur}
        readOnly
        className={inputClasses}
      />
      <button
        type="button"
        className="absolute top-[64%] right-5 -translate-y-2/4 cursor-pointer"
        onClick={() => !disabled && setToggle(!toggle)}
      >
        <CalenderIcon className="[&>g>path]:fill-neutral-tones-text" />
      </button>
      {toggle && (
        <div
          className={clsx(
            'bg-light-translucent-background dark:bg-dark-translucent-background rounded-10 shadow-button-box-shadow absolute left-0 z-10 p-8',
            otherClasses?.dropdownMainContainer,
            label ? 'top-24' : 'top-18',
          )}
        >
          <DayPicker
            captionLayout="dropdown"
            startMonth={startMonth}
            endMonth={endMonth}
            month={month}
            onMonthChange={setMonth}
            mode="single"
            disabled={
              startMonth ? { before: startMonth, after: endMonth } : undefined
            }
            autoFocus
            selected={value ? new Date(value) : undefined}
            onSelect={(e: any) => {
              onChange(e);
              setToggle(false);
            }}
            showOutsideDays
            className="main-container-date-picker"
            classNames={{
              weekday:
                '!text-xs font-bold font-inter-variable !text-neutral-tones-text/50 leadin-4 -tracking-form-label',
            }}
          />
        </div>
      )}
      {errorMessage !== '' && (
        <span className="font-inter-variable text-brand-posh-pink absolute -bottom-5 left-0 text-xs font-normal">
          {errorMessage}
        </span>
      )}
    </div>
  );
};

export default DatePicker;
